import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, IconButton, Divider, Avatar, Box, Fab, Skeleton } from '@mui/material';
import { Edit, SevenKPlusTwoTone } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import { baseUrl, get, patch, post } from '../../services/api-services';
import ProgramsDialog from '../../dialogs/ProgramsDialog';
import { useCommon } from '../../context/CommonContext';
import ModuleHeading from '../../component/ModuleHeading';
import CircularProgress from '@mui/material/CircularProgress';
import AddButton from '../../component/AddButton';

const ProgramSkeloton = () => {
    return (
        <CardContent>
            <Box className="flex items-center space-x-2">

                <Skeleton variant="circular" width={80} height={80} />
                <Box sx={{ mb: 2, flex: 1 }}>
                    <Skeleton variant="text" width="60%" height={30} />
                    <Skeleton variant="text" width="40%" height={20} />
                    <Skeleton variant="text" width="80%" height={20} />
                </Box>
            </Box>
        </CardContent>
    )
}


const Programs = () => {
    const [programsData, setProgramsData] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [errorInUploadImg, setErrorInUploadImage] = useState(false)
    const [programDetails, setProgramDetails] = useState({ title: '', description: '', price: '', duration: '', icon: null, createdAt: new Date(), updatedAt: new Date(), status: "active", color: "" });
    const [isEditMode, setIsEditMode] = useState(false);
    const { setSnackbar, currentUser } = useCommon();
    const [openStatus, setOpenStatus] = useState(false)
    const [loading, setLoading] = useState(false);
    const getAllPrograms = async () => {
        try {
            setLoading(true);
            const response = await get(`/Programs?filter={"order" : "createdAt DESC"}`);
            if (response?.statusCode === 200) {
                setProgramsData(response?.data);
                setLoading(false);
            }
        } catch (error) {
            console.error('Error fetching programs:', error);
        }
    };

    const handleDialogOpen = () => {
        setIsEditMode(false);
        setErrorInUploadImage(false);
        setProgramDetails({ title: '', description: '', price: '', duration: '', icon: null, createdAt: new Date(), updatedAt: new Date(), status: "active", color: "" });
        setOpenDialog(true);
    };

    const handleDialogClose = () => {
        setOpenDialog(false);

    };

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setErrorInUploadImage(false);
            setProgramDetails({
                ...programDetails,
                icon: file,
            });
        }
    };
    const handleChangeStatus = async () => {
        const response = await patch(`/Programs/${programDetails.id}?access_token=${currentUser?.accessToken}`, { status: programDetails?.status === 'active' ? 'inactive' : 'active' });
        if (response?.statusCode === 200) {
            setSnackbar({
                openSnackbar: true,
                message: 'Status updated successfully',
                severity: 'success'
            })
            getAllPrograms();
            setProgramDetails({ ...programDetails, status: response?.data?.status })
            setOpenStatus(false);
        } else {
            setSnackbar({
                openSnackbar: true,
                message: 'Something went wrong!',
                severity: 'error'
            })
        }
    }
    const handleSaveProgram = async () => {
        const formData = new FormData();
        formData.append('title', programDetails.title);
        formData.append('description', programDetails.description);
        formData.append('price', programDetails.price);
        formData.append('duration', programDetails.duration);
        if (programDetails?.icon && typeof programDetails.icon !== 'string') {
            formData.append('file', programDetails.icon);
            setErrorInUploadImage(false);
            const res = await post(`/Uploads/program/upload?access_token=${currentUser?.accessToken}`, formData)
            if (res?.statusCode === 200) {
                programDetails.icon = res?.data?.result?.files?.file[0]?.name
            }
        } else if (!programDetails?.icon && !isEditMode) {
            setErrorInUploadImage(true);
            return;
        }
        try {
            if (isEditMode) {
                let editObject = {
                    title: programDetails.title,
                    description: programDetails.description,
                    price: programDetails.price,
                    duration: programDetails.duration,
                }
                if (programDetails.icon) { editObject.icon = programDetails?.icon }
                const response = await patch(`/Programs/${programDetails.id}?access_token=${currentUser?.accessToken}`, editObject);
                if (response?.statusCode === 200) {
                    setSnackbar({
                        openSnackbar: true,
                        message: 'Program updated successfully',
                        severity: 'success'
                    })
                    getAllPrograms();
                    handleDialogClose();
                } else {
                    setSnackbar({
                        openSnackbar: true,
                        message: 'Something went wrong!',
                        severity: 'error'
                    })
                }
            } else {

                const response = await post(`/Programs?access_token=${currentUser?.accessToken}`, programDetails);
                if (response?.statusCode === 200) {
                    setSnackbar({
                        openSnackbar: true,
                        message: 'Program added successfully',
                        severity: 'success'
                    })
                    getAllPrograms();
                    handleDialogClose();
                } else {
                    setSnackbar({
                        openSnackbar: true,
                        message: 'Something went wrong!',
                        severity: 'error'
                    })
                }
            }


        } catch (error) {
            console.error('Error saving program:', error);
        }
    };

    const editProgramDialog = (program) => {
        setIsEditMode(true);
        // const program = programsData.find((prog) => prog.id === id);
        setProgramDetails({
            id: program.id,
            title: program.title,
            description: program.description,
            price: program.price,
            duration: program.duration,
            status: program.status,
            icon: program.icon || null,
        });
        setOpenDialog(true);
    };
    useEffect(() => {
        getAllPrograms();
    }, []);
    return (
        <Box sx={{flex: 1, display: 'flex', flexDirection: 'column', minHeight: '100vh',}}>
            <Box sx={{pt: 0, pb: 0, mb: 3, borderBottom: '1px solid', borderColor: 'divider', px: 0,}}>
                <ModuleHeading title="Programs" navigateTo="/admin/dashboard"/>
            </Box>

            <Box sx={{ px: 0, pb: 3 }}>
                {loading ? (
                    <>
                        {[...Array(5)].map((_, index) => (
                            <ProgramSkeloton key={index} />
                        ))}
                    </>
                ) : programsData?.length > 0 ? (
                    <Box>
                        {programsData.map((program) => (
                            <Card key={program.id} sx={{ mb: 2, cursor:
                                        currentUser?.role === 'admin' ? 'pointer' : 'default', transition: 'box-shadow 0.2s', '&:hover': { boxShadow: currentUser?.role === 'admin' ? 3 : 1, },}}
                                onClick={() => {
                                    if (currentUser?.role === 'admin') { 
                                        editProgramDialog(program);
                                    }}}>
                                <CardContent>
                                    <Box className="flex items-center space-x-2">
                                        <div
                                            className={`bg-[${program.color}] rounded-full p-5 ${
                                                program.status === 'inactive' ? 'opacity-15' : 'opacity-100'}`}>
                                            <Avatar
                                                src={`${baseUrl}/Uploads/program/download/${program.icon}`} alt=""/>
                                        </div>
                                        <Box sx={{ mb: 2, opacity: program?.status === 'inactive' ? 0.5 : 1,}}>
                                            <Typography variant="h6">
                                                {`WeightWonder™ ${ program.title || 'Untitled Program'}`}
                                            </Typography>

                                            <Typography
                                                variant="body2"
                                                color="secondary"
                                            >
                                                ₹{program.price || '0'},{' '}
                                                {program.duration || '0'} days
                                            </Typography>

                                            <Typography
                                                variant="body2"
                                                color="textSecondary"
                                            >
                                                {program.description ||
                                                    'No description available.'}
                                            </Typography>
                                        </Box>

                                        <Box sx={{ flexGrow: 1 }} />

                                        {currentUser?.role === 'admin' && (
                                            <IconButton
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    editProgramDialog(program);
                                                }}
                                            >
                                                <Edit color="primary" />
                                            </IconButton>
                                        )}
                                    </Box>
                                </CardContent>

                                <Divider />
                            </Card>
                        ))}
                    </Box>
                ) : (
                    <Typography
                        variant="body2"
                        className="flex justify-center flex-1 items-center"
                    >
                        No programs found. Added programs will be shown here.
                    </Typography>
                )}

                {currentUser?.role === 'admin' && (
                    <AddButton onOpen={handleDialogOpen} />
                )}

                <ProgramsDialog
                    open={openDialog}
                    onClose={handleDialogClose}
                    isEditMode={isEditMode}
                    handleSaveProgram={handleSaveProgram}
                    programDetails={programDetails}
                    handleImageUpload={handleImageUpload}
                    setProgramDetails={setProgramDetails}
                    onChangeStatus={handleChangeStatus}
                    openStatus={openStatus}
                    setOpenStatus={setOpenStatus}
                    errorInUploadImg={errorInUploadImg}
                >
                    {isEditMode && programDetails.icon && (
                        <div>
                            <img src={`${baseUrl}/Uploads/program/download/${programDetails.icon}`} alt="Program Icon" width={100}/>
                        </div>
                    )}
                </ProgramsDialog>
            </Box>
        </Box>
    );
}   
export default Programs;